var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-top": "8px" },
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("CargoMsg.EmailParsingSettings"),
                name: "emailParsingSettings"
              }
            },
            [
              _c("div", { staticClass: "grid-view" }, [
                _c("div", { staticClass: "main-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "cargo-advance-search",
                      staticStyle: {
                        width: "100%",
                        "margin-top": "5px",
                        "min-width": "1280px"
                      }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-position": "middle",
                            "label-width": "100px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "el-form-item-wrapper",
                              staticStyle: { display: "flex" }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.TENANT_BUSINESS_NAME"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: {
                                      width: "230px",
                                      "padding-left": "10px"
                                    },
                                    attrs: {
                                      no: "1",
                                      "select-type": _vm.selectTypeNames.TENANT,
                                      cache: false,
                                      filterable: "",
                                      "custom-label": function(item) {
                                        return "[" + item.id + "]" + item.name
                                      },
                                      "callback-method-type": "obj",
                                      "default-value":
                                        String(_vm.filter.tenant) || ""
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.filter.tenant = p.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Partners.emailAddress2")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "230px",
                                      "padding-left": "10px"
                                    },
                                    attrs: { no: "2", clearable: "" },
                                    model: {
                                      value: _vm.filter.address,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "address", $$v)
                                      },
                                      expression: "filter.address"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "padding-left": "10px" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "3", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.filter.pageNum = 1
                                          _vm.queryHandler()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Query")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "4", type: "primary" },
                                      on: { click: _vm.addHandler }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Add")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "5", type: "primary" },
                                      on: { click: _vm.editHandler }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Edit")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "6", type: "danger" },
                                      on: { click: _vm.deleteHandler }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_OrderDelete")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid",
                      staticStyle: { "flex-grow": "1" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        attrs: {
                          no: "grid",
                          "config-module": "101423",
                          "column-defs": _vm.columnDefs,
                          "row-data": _vm.rowData,
                          "grid-params": _vm.girdParams,
                          "grid-options": _vm.gridOptions
                        },
                        on: {
                          "update:gridParams": function($event) {
                            _vm.girdParams = $event
                          },
                          "update:grid-params": function($event) {
                            _vm.girdParams = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "app-main-inner-row row-pagination" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          no: "pagination",
                          "config-module": "101424",
                          total: _vm.total,
                          page: _vm.filter.pageNum,
                          limit: _vm.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(_vm.filter, "pageNum", $event)
                          },
                          "update:limit": function($event) {
                            return _vm.$set(_vm.filter, "pageSize", $event)
                          },
                          pagination: _vm.queryHandler
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_GetReceiptSettings"),
                name: "receiptSettings"
              }
            },
            [_c("receipt-settings")],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "settingDialog",
          attrs: {
            visible: _vm.settingDialog.visible,
            title: _vm.settingDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.settingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-width": "130px", "label-position": "right" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lable-blue",
                      attrs: { label: _vm.$t("CargoMsg.TENANT_BUSINESS_NAME") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "7",
                          "select-type": _vm.selectTypeNames.TENANT,
                          disabled: _vm.settingDialog.isEdit,
                          cache: false,
                          filterable: "",
                          "custom-label": function(item) {
                            return "[" + item.id + "]" + item.name
                          },
                          "callback-method-type": "obj",
                          "default-value":
                            String(_vm.settingDialog.form.tenant) || "",
                          "static-options": _vm.tenants
                        },
                        on: { parentCallBack: _vm.changeTenant }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lable-blue",
                      attrs: { label: _vm.$t("Partners.emailAddress2") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "8", clearable: "" },
                        model: {
                          value: _vm.settingDialog.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "address", $$v)
                          },
                          expression: "settingDialog.form.address"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.EmailPasswordAuthorizationCode")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "9", clearable: "" },
                        model: {
                          value: _vm.settingDialog.form.password,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "password", $$v)
                          },
                          expression: "settingDialog.form.password"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.SenderServer") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "10", clearable: "" },
                        model: {
                          value: _vm.settingDialog.form.server,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "server", $$v)
                          },
                          expression: "settingDialog.form.server"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Port") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "11", clearable: "" },
                        model: {
                          value: _vm.settingDialog.form.serverPort,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "serverPort", $$v)
                          },
                          expression: "settingDialog.form.serverPort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lable-blue",
                      attrs: { label: _vm.$t("CargoMsg.EmailPurpose") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "12" },
                          model: {
                            value: _vm.settingDialog.form.purpose,
                            callback: function($$v) {
                              _vm.$set(_vm.settingDialog.form, "purpose", $$v)
                            },
                            expression: "settingDialog.form.purpose"
                          }
                        },
                        _vm._l(_vm.EMAIL_PARSING_TYPE, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.$getLangColumn(item),
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "13", type: "primary" },
                  on: { click: _vm.saveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "14" },
                  on: {
                    click: function($event) {
                      _vm.settingDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }